export default {
  namespaced: true,
  state: {
    HOME: {
      icon: 'mdi-home-circle-outline',
      text: 'Home',
      to: {
        name: 'home',
      },
    },
    DASHBOARD: {
      icon: 'mdi-view-dashboard-variant',
      text: 'Dashboard',
      to: {
        name: 'dashboard',
      },
    },
    REGISTER: {
      icon: 'mdi-account-plus-outline',
      text: 'Create Account',
      to: {
        name: 'register',
      },
    },
    LOGIN: {
      icon: 'mdi-login-variant',
      text: 'Sign In',
      to: {
        name: 'login',
      },
    },
    RESET_PASSWORD: {
      icon: 'mdi-lock-reset',
      text: 'Reset Now',
      to: {
        name: 'forgot-password',
      },
    },
    LOGOUT: {
      icon: 'mdi-logout-variant',
      text: 'Log off',
      to: {
        name: 'logout',
      },
    },
    ACCOUNT: {
      icon: 'mdi-account-circle-outline',
      text: 'My Account',
      to: {
        name: 'account',
      },
    },
    SETTINGS: {
      icon: 'mdi-settings',
      text: 'Settings',
      to: {
        name: 'settings',
      },
    },
    PROJECTS: {
      icon: 'mdi-file-document-box-check-outline',
      text: 'Projects',
      to: {
        name: 'projects',
      },
    },
    NEW_PROJECT: {
      icon: 'mdi-file-document-box-plus-outline',
      text: 'New Project',
      to: {
        name: 'add-project',
      },
    },
    ISSUES: {
      icon: 'mdi-flag-checkered',
      text: 'Tasks',
      to: {
        name: 'issues',
      },
    },
    ESTIMATES_LIST: {
      icon: 'mdi-calculator-variant',
      text: 'Estimates',
      to: {
        name: 'estimates',
      },
    },
    CONTACTS_LIST: {
      icon: 'mdi-account-box-outline',
      text: 'Contacts',
      to: {
        name: 'contacts',
      },
    },
    ADMIN_PANEL: {
      icon: 'mdi-settings-outline',
      text: 'Admin Panel',
      to: {
        name: 'admin-panel',
      },
      roles: ['admin'],
    },
    TYPES_LIST: {
      icon: 'mdi-calculator-variant',
      text: 'Categories',
      to: {
        name: 'project-types',
      },
    },
    PLANS_LIST: {
      icon: 'mdi-calculator-variant',
      text: 'Plans',
      to: {
        name: 'plans',
      },
    },
    STAGES_LIST: {
      icon: 'mdi-calculator-variant',
      text: 'Stages',
      to: {
        name: 'stages',
      },
    },
    FEATURES_LIST: {
      icon: 'mdi-calculator-variant',
      text: 'Features',
      to: {
        name: 'features',
      },
    },
    ALL_TIMESHEETS: {
      icon: 'mdi-timeline-clock-outline',
      text: 'Timesheets',
      to: {
        name: 'all-timesheets-list',
      },
    },
    ALL_EXPENSES: {
      icon: 'mdi-cash-register',
      text: 'Expenses',
      to: {
        name: 'all-expenses-list',
      },
      roles: ['admin'],
    },
    PROJECT_INFO: {
      icon: 'mdi-file-document-box-check-outline',
      text: 'Project Info',
      to: {
        name: 'project-view',
      },
    },
    PROJECT_ACCOUNTS: {
      icon: 'mdi-account-multiple-outline',
      text: 'Accounts',
      to: {
        name: 'project-accounts',
      },
    },
    PROJECT_EXPENSES: {
      icon: 'mdi-calculator-variant',
      text: 'Expenses',
      to: {
        name: 'project-expenses',
      },
    },
    PROJECT_TIMESHEETS: {
      icon: 'mdi-calculator-variant',
      text: 'Timesheets',
      to: {
        name: 'project-timesheets',
      },
    },
    ROLES_LIST: {
      icon: 'mdi-calculator-variant',
      text: 'Roles',
      to: {
        name: 'roles',
      },
    },
    USERS_LIST: {
      icon: 'mdi-calculator-variant',
      text: 'Users',
      to: {
        name: 'users',
      },
    },
    TOOLS_LIST: {
      icon: 'mdi-calculator-variant',
      text: 'Tools',
      to: {
        name: 'tools',
      },
    },
    EFFORT_ESTIMATOR_TOOL: {
      icon: 'mdi-calculator-variant',
      text: 'Effort Estimator',
      caption: 'Estimate freelance effort and compare with budget',
      to: {
        name: 'effort-estimator-tool',
      },
    },
    SALARY_ESTIMATOR_TOOL: {
      icon: 'mdi-calculator-variant',
      text: 'Salary Estimator',
      caption: 'Estimate salary with diff. increment',
      to: {
        name: 'salary-estimator-tool',
      },
    },
    BUDGET_PLANNER_TOOL: {
      icon: 'mdi-calculator-variant',
      text: 'Budget Planner',
      caption: 'Plan your yearly budget based on income',
      to: {
        name: 'budget-planner-tool',
      },
    },
    TAX_CALCULATOR_TOOL: {
      icon: 'mdi-calculator-variant',
      text: 'Tax Calculator',
      caption: 'Calculate yearly tax based on your salary',
      to: {
        name: 'tax-calculator-tool',
      },
    },
    PROJECT_LIST_EDIT: {
      icon: 'mdi-flag-checkered',
      text: 'Edit Project',
      to: {
        name: 'edit-project',
      },
    },
    PROJECT_TASKS: {
      icon: 'mdi-flag-checkered',
      text: 'Tasks',
      to: {
        name: 'project-issues-home',
      },
    },
    PROJECT_ISSUE: {
      icon: 'mdi-flag-checkered',
      text: 'Issue',
      to: {
        name: 'project-issue',
      },
    },
    GOALS: {
      icon: 'mdi-flag-checkered',
      text: 'Goals',
      to: {
        name: 'goals',
      },
    },
  },
  getters: {
    sideNavItems: state => [
      state.DASHBOARD,
      state.PROJECTS,
      // state.ISSUES,
      state.ESTIMATES_LIST,
      state.GOALS,
      state.ALL_EXPENSES,
      state.ALL_TIMESHEETS,
      state.TOOLS_LIST,
      state.ADMIN_PANEL,
    ],
    accountDropdownItems: state => [
      state.ACCOUNT,
      state.SETTINGS,
      state.LOGOUT,
    ],
    adminPanelTabItems: state => [
      state.USERS_LIST,
      state.TYPES_LIST,
      state.STAGES_LIST,
      state.FEATURES_LIST,
      state.PLANS_LIST,
      state.CONTACTS_LIST,
    ],
    projectTabItems: state => [
      state.PROJECT_INFO,
      state.PROJECT_TASKS,
      state.PROJECT_ACCOUNTS,
    ],
    issueBreadcrumb: state => [
      state.DASHBOARD,
      state.PROJECT_INFO,
      state.PROJECT_ISSUE,
    ],
    projectBreadcrumb: state => [
      state.DASHBOARD,
      state.PROJECTS,
      state.PROJECT_INFO,
    ],
    toolsTabItems: state => [
      state.EFFORT_ESTIMATOR_TOOL,
      state.BUDGET_PLANNER_TOOL,
      state.TAX_CALCULATOR_TOOL,
    ],
  },
  mutations: {},
  actions: {},
};
